define('views/comments/reply-form',[
  "globals",
  "../abstract-comments/create-form"
], function (globals, AbstractCommentFormView) {
  "use strict";

  return AbstractCommentFormView.extend({
    CREATE_EVENT_NAME: "create:reply",

    initialize: function () {
      var parentId;

      if (this.model.has("parentId")) {
        parentId = this.model.get("parentId");
      } else {
        parentId = this.model.get("id");
      }

      this.parentComment = this.collection.get(parentId);
      AbstractCommentFormView.prototype.initialize.call(this);
    },

    render: function () {
      AbstractCommentFormView.prototype.render.call(this);
      return this.updatePlaceHolder();
    },

    serialize: function () {
      return _.extend(AbstractCommentFormView.prototype.serialize.call(this),
        { parentId: this.parentComment.get("id") });
    },

    submit: function (e) {
      e.preventDefault();

      var json = this.serialize();
      json.attachment = document.getElementById("attachment").value;

      if (json.attachment !== "") {
        this.createAttachment(json)
      } else {
        this.createComment(json);
      }

      this.reset();
      setTimeout(function () {
        $(document.getElementById("loadingComments")).show();
        $(document.getElementById("show-form")).hide();       
      }, 0);
    },

    createAttachment: function (json) {
      var thisScope = this;
      var attachForm = document.getElementById("attach-form");
      attachForm.action = attachForm.action.substring(0, attachForm.action.length - 1) + json.created;
      json.attachment = json.created + "_" + json.attachment.replace(/^.*\\/, "");

      $(".file").each(function () {
        if (this.files.length > 0) {
          var data = new FormData();
          this.files[0].filename = json.attachment
          data.append("attachment", this.files[0]);

          $.ajax({
            url: attachForm.action,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            method: "POST",
            type: "POST", // For jQuery < 1.9
            success: function () {
              thisScope.createComment(json);
            },
            error: function (jqXHR) {
              alert(jqXHR.responseText);
            }
          });
        }

      });

    },

    createComment: function (json) {
      this.collection.create(json, {
        success: _.bind(function (model) {
          this.parentComment.trigger(this.CREATE_EVENT_NAME, model);
          this.collection.trigger(this.CREATE_EVENT_NAME, model);
          setTimeout(function () {
            $(document.getElementById("loadingComments")).hide();
            $(document.getElementById("show-form")).show();       
          }, 0);
        }, this)
      });

    },


    reset: function () {
      AbstractCommentFormView.prototype.reset.call(this);
      this.remove();
    },

    updatePlaceHolder: function () {
      var placeholder =
        Messages("comment.reply.input.placeholder", this.model.get("author").name);

      this.$textarea.val("").attr("placeholder", placeholder);
      return this;
    }
  });
});

